import { useQuery } from '@tanstack/react-query'

import { fetchBriefing, fetchInsights, type BriefingItem } from '../app/api/insightsApi'

export function useChatLauncherPriorities() {
  const briefing = useQuery({
    queryKey: ['inbox-briefing'],
    queryFn: fetchBriefing,
    staleTime: 0,
    refetchOnMount: 'always',
  })
  const briefingEmpty = briefing.isSuccess && (briefing.data?.items.length ?? 0) === 0
  // No reviewed briefing yet (fresh user): fall back to the onboarding items
  // only. Everything else must be elected by the prioritization agent.
  const insights = useQuery({
    queryKey: ['insights'],
    queryFn: fetchInsights,
    staleTime: 0,
    refetchOnMount: 'always',
    enabled: briefingEmpty,
  })
  const fallback: BriefingItem[] = (insights.data ?? [])
    .filter((item) => item.triage === null && item.fingerprint.startsWith('question/onboarding/'))
    .slice(0, 3)
    .map((item, index) => ({
      rank: index + 1,
      whyNow: '',
      fingerprint: item.fingerprint,
      title: item.title,
      severity: item.severity,
      summary: item.body,
      suggestedAction: item.action,
      updatedAt: item.computedAt,
    }))

  return {
    loading: briefing.isLoading || (briefingEmpty && insights.isLoading),
    priorities: briefing.data?.items.length ? briefing.data.items.slice(0, 3) : fallback,
  }
}
